<div class="common-text-input__container-header-sequential">
  <div class="common-text-input__header-label-sequential">
    @if(field.fieldTypeFrontId === 'bool' && field.isHighlight){
      <i class="lf-icon-important common-icon__md-code-color-yellow"></i>
    }
    <div class="common-text-input__text-label-sequential">{{fieldSequentialHeader.titleField}}</div>
    @if (field.required) {
      <div class="common-tag__mandatory-obligatory-message">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory landing-page__desktop-tablet"
          [afTranslate]="'common.required-with-bracket'">(obligatorio)</span>
      </div>
    }
  </div>
  @if (field.description && field.fieldTypeFrontId !== 'rich-editable') {
    <div class="common-text-input__header-info-sequential">
      <div class="common-text-input__text-info-sequential"
        [innerHTML]="field.description"></div>
    </div>
  }
</div>
